import { gql, TypedDocumentNode } from '@apollo/client';
import { BankCode } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { CurrencyType } from '@libs/types';

export type GetMerchantsForAssetArgs = {
  assetCode: CurrencyType.GEL | CurrencyType.USD;
};
export type Merchants = {
  createdAt?: string;
  isActive?: boolean;
  name: string;
  primaryBankCode: BankCode;
  updatedAt?: string;
};
export type GetMerchantsForAssetResponse = {
  getMerchantsForAsset: DefaultApiResponse<Merchants[]>;
};
export const getMerchantsForAssetQuery: TypedDocumentNode<
  GetMerchantsForAssetResponse,
  DefaultArg<GetMerchantsForAssetArgs>
> = gql`
  query GetMerchantsForAsset($record: GetMerchantsForAssetRecord!) {
    getMerchantsForAsset(record: $record) {
      createdAt
      isActive
      name
      primaryBankCode
      updatedAt
    }
  }
`;
